import { gql } from '@apollo/client';

/**
 * scio1 parity — ports `app.account.subscriptionCoupons` to scio3 native.
 * Backend filters status IN [null, 'finished']; omitted display fields (description,
 * deviceFreeId, accountId, apiId) are not rendered by scio1.
 */
export const GET_COUPONS = gql`
  query getCoupons($first: Int, $after: String) {
    getCoupons(first: $first, after: $after) {
      page {
        edges {
          node {
            _id
            coupon
            couponNumber
            couponUsed
            price
            createdAt
            expiredAt
          }
        }
      }
    }
  }
`;

export interface CouponNode {
  _id: string;
  coupon: string;
  couponNumber: number;
  couponUsed: number;
  price: number | null;
  createdAt: string;
  expiredAt: string;
}

export interface GetCouponsResult {
  getCoupons: Array<{
    page: {
      edges: Array<{ node: CouponNode }>;
    };
  }>;
}

export interface GetCouponsVariables {
  first?: number;
  after?: string;
}
